import {
  ORGANIZATION_ACCESS_STATE,
  ORGANIZATION_INFORMATION,
  ORGANIZATION_USER_PROFILE,
} from '../../constants';
import { getItem } from '../../utils/localStorage';
// import { config } from '../../utils/utils';
import { InitialState } from './interface';

const selectedItem = {
  organization_user_profile: ORGANIZATION_USER_PROFILE,
  organizationAccess: ORGANIZATION_ACCESS_STATE,
  organizationInfo: ORGANIZATION_INFORMATION,
};

// const result = getItem(config.ORGANIZATION_ACCESS);
const organizationInfo = getItem('oinfo');
const organization_user_profile = getItem('organization_user_profile');

// if (result) {
//   selectedItem.organizationAccess = result;
// }
if (organization_user_profile) {
  selectedItem.organization_user_profile = organization_user_profile;
}

if (organizationInfo) {
  selectedItem.organizationInfo = organizationInfo;
}

export const initialState: InitialState = {
  selectedItem,
  redirectToInvitation: false,
};
